// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"93":"list","177":"home","180":"story"}[chunkId] + "-" + {"93":"64d3b1d2ccb7608d4440","177":"67c830fd17e368ed55d2","180":"d011373d5c48e7daaa79"}[chunkId] + ".css";
};